import Reveal from './Reveal';

const services = [
  {
    num: '01',
    title: 'Tax Preparation',
    copy: 'Meticulous, timely returns prepared by people who know your name — not a seasonal call center.',
    points: ['Individual & business returns', 'Multi-state filing', 'IRS & state correspondence'],
  },
  {
    num: '02',
    title: 'Tax Planning',
    copy: 'Proactive, year-round strategy so April holds no surprises and every decision is tax-aware.',
    points: ['Year-round strategy sessions', 'Entity & compensation structure', 'Retirement & estate coordination'],
  },
  {
    num: '03',
    title: 'Fractional CFO',
    copy: 'Executive-level financial leadership for your practice, without the executive-level payroll.',
    points: ['Cash flow forecasting', 'Budgeting & management reporting', 'Growth & profitability strategy'],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-cream py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            <span className="eyebrow-rule" />
            What we do
          </p>
          <h2 data-testid="services-heading" className="font-serif tracking-tight text-navy text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[1.08]">
            Three disciplines, one <span className="italic text-gold">standard of care.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-3 gap-px bg-navy/10 border border-navy/10">
          {services.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12} className="h-full">
              <article
                data-testid={`service-card-${s.num}`}
                className="group bg-cream h-full p-10 lg:p-12 transition-colors duration-500 hover:bg-sand flex flex-col"
              >
                <span className="font-serif italic text-gold text-lg">{s.num}</span>
                <h3 className="font-serif text-navy text-3xl mt-6 tracking-tight">{s.title}</h3>
                <p className="text-slateink font-light leading-relaxed text-sm mt-5">{s.copy}</p>
                <ul className="mt-8 pt-8 border-t border-navy/10 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm text-navy/80 font-light">
                      <span className="mt-[7px] inline-block w-1.5 h-1.5 bg-gold rotate-45 shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
                <span className="mt-auto pt-10 block w-8 h-px bg-gold transition-all duration-500 group-hover:w-full" aria-hidden="true" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
